module.exports = __webpack_public_path__ + "img/tula.cfd1dd04.jpg";